import React from 'react'

import { BrandABB, BrandAccenture, BrandAppenzeller, BrandArvato, BrandASA, BrandBMWGroup, BrandCreditSuisse, BrandEbookers, BrandMars, BrandPost, BrandProHelvetia, BrandRoche, BrandSAP, BrandSBB, BrandSwatch, BrandSwisslife, BrandTelekom, BrandUBS, BrandUnionInvestment, BrandWaltDisney } from '.'

const Brands = ({ name }) => {
  switch (name) {
    case 'ABB':
      return <BrandABB />
    case 'Accenture':
      return <BrandAccenture />
    case 'Appenzeller':
      return <BrandAppenzeller />
    case 'Arvato':
      return <BrandArvato />
    case 'ASA':
      return <BrandASA />
    case 'BMW':
      return <BrandBMWGroup />
    case 'CreditSuisse':
      return <BrandCreditSuisse />
    case 'Ebookers':
      return <BrandEbookers />
    case 'Mars':
      return <BrandMars />
    case 'Post':
      return <BrandPost />
    case 'ProHelvetia':
      return <BrandProHelvetia />
    case 'Roche':
      return <BrandRoche />
    case 'SAP':
      return <BrandSAP />
    case 'SBB':
      return <BrandSBB />
    case 'Swatch':
      return <BrandSwatch />
    case 'SwissLife':
      return <BrandSwisslife />
    case 'Telekom':
      return <BrandTelekom />
    case 'UBS':
      return <BrandUBS />
    case 'UnionInvestment':
      return <BrandUnionInvestment />
    case 'WaltDisney':
      return <BrandWaltDisney />
    default:
      return <BrandABB />
  }
}

export default Brands
